import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IAssetAllTransactionsHistoryDto } from '~/models/modules/Asset/History/allHistory';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AssetAllHistoryService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }

  getAssetAllHistoryGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<IAssetAllTransactionsHistoryDto[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  getAssetHistoryGrid(paramsObj?: any, model?: any, assetNumber?:string) {
    paramsObj = paramsObj || {};
    paramsObj.assetNumber = assetNumber; //asset number for filter
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<IAssetAllTransactionsHistoryDto[]>(this._url(`/asset-history`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AllTransactionsHistory${v}`);
  }
}
